import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-19157ad3"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "category-list"
};
var _hoisted_2 = {
  class: "category-name"
};
var _hoisted_3 = {
  class: "category-count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");

  var _component_kila_kila_card = _resolveComponent("kila-kila-card");

  return _openBlock(), _createBlock(_component_kila_kila_card, {
    icon: ['fas', 'folder'],
    iconColor: "#fcd53f",
    title: "分类"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categoryCounts, function (category) {
        return _openBlock(), _createBlock(_component_router_link, {
          key: category.id,
          to: "/category/".concat(category.id),
          class: "category-item"
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_2, _toDisplayString(category.name), 1), _createElementVNode("span", _hoisted_3, _toDisplayString(category.count), 1)];
          }),
          _: 2
        }, 1032, ["to"]);
      }), 128))])];
    }),
    _: 1
  });
}